<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div style="background-size: cover; background-position:center; padding-top:27vh; padding-bottom:27vh"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'peat-header.jpg)'}">
        <div class="row">
            <div style="width:22%"></div>
            <div class="text-center whiteText" style="width:56%">
                <h1 class="DINNextLTPro-Black whiteText" style="font-size:43px; text-transform: uppercase;">Harrell's
                    Peat</h1>
            </div>
            <div style="width:22%"></div>
        </div>
        <div class="row">
            <div style="width:22%"></div>
            <div class="text-center whiteText" style="width:56%">
                <h2 class="DIN2014Regular whiteText" style="font-size:19px;line-height:30px;letter-spacing: .38px;">
                    Professional, top of the line soil media.</h2>
            </div>
            <div style="width:22%"></div>
        </div>
    </div>
</div>
<div class="row whiteBackground">
    <div class="col-md-2"></div>
    <div class="col-md-8 text-center" style="padding-top:3%; padding-bottom:3%">
        <h3 class="DIN2014Regular blackText" style="font-size: 24px; line-height: 33px;letter-spacing: .48px;">
            Harvested with our new custom mining machine, we efficiently separate moisture and silt from the rich,
            natural peat ensuring a pure and clean peat base of your custom-blended media mix.<br><br>
            Harrell's Peat is then mixed with the best raw media ingredients available to make your custom-blended soil.
            No compost, yard waste or landfill products. From coir and sphagnum to pine bark and perlite, these products
            are mixed with the largest, most accurate in-line mixer in the industry. Harrell's PROfertilizer® featuring
            POLYON® combined with Harrell’s rich, pure peat from central Florida is your path to success!

        </h3>
    </div>
    <div class="col-md-2"></div>
</div>

<div class="row pt-3">
    <div class="col-lg-6 greenText lightCremeBackground" style="padding-right:0px; padding-left:0px; padding-top:5%">
        <h3 class="Caecilia76BoldItalic" style="text-align: right; margin-right:5%; font-size:28px; line-height: 36px;">
            Florida Peat Benefits</h3>
        <div class="d-flex justify-content-end">
            <img style="width:10vw; margin-right:5%" src="{{this.baseImagePaths + 'dots.png'}}" alt="market dots image">
        </div>
    </div>
    <div class="col-lg-6 blueText lightCremeBackground"
        style="padding-left:0px; text-align: left;padding-top:5%; padding-bottom:5%">
        <!-- <h3 class="DIN2014Bold" style="text-align: left; font-size:28pt; line-height: 1.5;"><div class="numberCircleBlue DINNextLTPro-Black" style="line-height:1.5;font-size:20pt;display:inline">30</div> Build Your Program</h3> -->
        <h3 class="DIN2014Bold" style="font-size:26px;line-height:26px"><span
                style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                class="DINNextLTPro-Black blueBackground whiteText">1</span>&nbsp;&nbsp;&nbsp;Superior Physical
            Characteristics</h3>
        <h3 class="DIN2014Bold" style="font-size:26px; margin-top:3%"><span
                style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                class="DINNextLTPro-Black blueBackground whiteText">2</span>&nbsp;&nbsp;&nbsp;Lighter In Weight</h3>
        <h3 class="DIN2014Bold" style="font-size:26px; margin-top:3%"><span
                style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                class="DINNextLTPro-Black blueBackground whiteText">3</span>&nbsp;&nbsp;&nbsp;More Fibrous </h3>
        <h3 class="DIN2014Bold" style="font-size:26px; margin-top:3%"><span
                style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                class="DINNextLTPro-Black blueBackground whiteText">4</span>&nbsp;&nbsp;&nbsp;Higher Airspace And
            Porosity </h3>
        <h3 class="DIN2014Bold" style="font-size:26px; margin-top:3%"><span
                style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                class="DINNextLTPro-Black blueBackground whiteText">5</span>&nbsp;&nbsp;&nbsp;Quick Post-Harvest
            Turnaround Time </h3>
        <h3 class="DIN2014Bold" style="font-size:26px; margin-top:3%"><span
                style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                class="DINNextLTPro-Black blueBackground whiteText">6</span>&nbsp;&nbsp;&nbsp;Same Organic Carbon
            Content As Canadian Peat </h3>
    </div>
</div>
<div class="row whiteBackground">
    <div class="col-md-2"></div>
    <div class="col-md-8 text-center" style="padding-top:3%; padding-bottom:3%">
        <h3 class="DIN2014Regular blackText" style="font-size: 24px; line-height: 33px;letter-spacing: .48px;">
            In Florida, reed sedge peat is mined in underwater bogs. Freshly harvested peat must be piled up and allowed to drain for months before it can be blended into potting media. Working wet peat damages the peat fibers, reducing the physical quality of the product. <br><br>
            The lighter, drier Harrell's Peat enables growers to have a physically superior Florida peat – based media without the added cost of imported substrate ingredients. The reduced bulk density of Peat enables more cubic yards of media per truckload, further reducing shipping costs of bulk potting soil.
        </h3>
    </div>
    <div class="col-md-2"></div>
</div>
<div class="row blueBackground">
    <div class="col-md-2"></div>
    <div class="col-md-8 text-center" style="padding-bottom:3%">
        <h3 class="DINNextLTPro-Black whiteText"
            style="font-size:30px; line-height:44px; text-transform: uppercase; text-align: center; margin-top:5%">
            HARRELL'S IS READY TO BE YOUR COMPLETE PLANT CARE PROVIDER</h3>
        <h3 style="margin-top:3%"><a class="DIN2014Bold whiteBackground greenText"
            style="font-size:20px ;padding:8pt; text-decoration: none !important" href='/findrep'>CONNECT WITH YOUR REP</a>
    </h3>
    </div>
    <div class="col-md-2"></div>
</div>